// page: groups add ----------------------------------------
export function handleEnterKey(e) {
  if (e.which === 13) {
    addMember();
  }
}
export function addMember() {
  const memberName = $('#groupMember').val();
  const tag = $(`<span class="groupMembersTag">${memberName} <span class="memberDelete" title="Delete Member">X</span></span>`);
  if (memberName !== '') {
    $('.createdResutl__content-Members').append(tag);
  }
}

export function memberDelete() {
  $(this).parent().fadeOut(200, function () {
    $(this).remove();
  });
}

export function groupName() {
  const groupName = $('#groupName').val();
  $('.createdGroupName').text(groupName);

}
// page: groups view ----------------------------------------



//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/groups/_groups.js
// module id = 22
// module chunks = 0